import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { WorkComponent } from './work/work.component';
import { EducationComponent } from './education/education.component';
import { ResultsComponent } from './results/results.component';
import { SpeakingComponent } from './speaking/speaking.component';
import { ContactComponent } from './contact/contact.component';
import { Page404Component } from './page404/page404.component';
import { DeepcrawlComponent } from './work/deepcrawl/deepcrawl.component';
import { DiscipleComponent } from './work/disciple/disciple.component';
import { AllotmentDigitalComponent } from './work/allotment-digital/allotment-digital.component';
import { VinnaComponent } from './work/vinna/vinna.component';
import {InfringementReportComponent} from './work/infringement-report/infringement-report.component';
import { RegusComponent } from './results/regus/regus.component'; 
import { TheSpaceComponent } from './results/the-space/the-space.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    WorkComponent,
    EducationComponent,
    ResultsComponent,
    SpeakingComponent,
    ContactComponent,
    Page404Component,
    DeepcrawlComponent,
    DiscipleComponent,
    AllotmentDigitalComponent,
    VinnaComponent,
    InfringementReportComponent,
    RegusComponent,
    TheSpaceComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'alecbertram.com' }),
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/app.module.ts